<template>
    <div class="cmp-tabs">
        <div class="cmp-tabs-header">
            <div class="cmp-tabs-header-left">
                <div class="cmp-tab-items">
                    <div :class="['cmp-tab-item', 'compare-versions', getItem('activeTab') == 'compare-versions' ? 'active': '']"
                        @click="setActivePage({activeTab: 'compare-versions', tabPage: 'compare-toc'})">
                        <span>{{ $t('frm_compare_versions') }}</span>
                    </div>
                    <div :class="['cmp-tab-item', 'compare-history', getItem('activeTab') == 'compare-history' ? 'active': '']"
                        @click="setActivePageForCompareHistory({activeTab: 'compare-history', tabPage: ''})">
                        <span>{{ $t('frm_history') }}</span>
                    </div>
                </div>
            </div>
            <div class="cmp-tabs-header-right">
                <slot name="headerright"></slot>
            </div>
        </div>
        <div class="cmp-tabs-body">
            <slot name="body"></slot>
        </div>
    </div>
</template>
<script>
       import { createNamespacedHelpers } from 'vuex';
       const { mapActions: aiCompareMapActions, mapGetters: aiCompareMapGetters } = createNamespacedHelpers('aicompare')
    export default {
        name: "CompareTabs",
        computed: {
            ...aiCompareMapGetters([
                'getItem'
            ])
        },
        methods: {
            ...aiCompareMapActions([
                'setItem',
                'abortApiCall',
                'setActivePage',
                'setActivePageForCompareHistory'
            ])
        }
    }
</script>